<template>
  <div class="login">
    <!-- Page content -->
    <div class="container">
      <div class="row justify-content-center">
        <div class="offset-lg-1 col-lg-5 col-md-12 col-sm-12">
          <div class="border-0 mb-0">
            <div class="bg-transparent pb-5">
              <div class="text-muted text-center mt-2 mb-3">
                <h1>Log In</h1>
                <h1><b>and Power Up!</b></h1>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="Username"
                    :rules="{ required: true }"
                    prepend-icon="ni ni-single-02"
                    placeholder="Username"
                    v-model="model.email"
                    v-on:keyup="inputChanged()"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Password"
                    :rules="{ required: true, min: 6 }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Password"
                    v-model="model.password"
                    v-on:keyup="inputChanged()"
                  >
                  </base-input>
                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="btn-block my-4"
                      >Sign in</base-button
                    >
                  </div>
                  <pre class="text-danger" v-if="error">{{ error }}</pre>
                </form>
              </validation-observer>
            </div>
          </div>
        </div>
        <div class="col-1">
          <div class="separator-v"></div>
        </div>

        <div class="col-lg-5 col-md-12 col-sm-12">
          <div class="text-center">
            <h4><b>powered by</b></h4>
            <img src="/img/simplyup_logo_square.svg" />
          </div>
        </div>
      </div>
      <hr />
      <div class="col-md-12 text-center">
        Contact us at
        <a href="mailto:admin@simplysakal.asia">admin@simplysakal.asia</a> to
        request for an account
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import router from "@/routes/router";
export default {
  data() {
    return {
      model: {
        email: "",
        password: ""
      },
      error: ""
    };
  },
  methods: {
    onSubmit() {
      // log in
      store
        .dispatch("user/login", this.model)
        .then(() => {
          router.push({ path: "board" });
        })
        .catch(e => {
          // console.log("e", e);
          this.error = `Invalid log in credentials`;
        });
    },
    clear() {
      this.model = {
        email: "",
        password: ""
      };
      this.error = "";
    },
    inputChanged() {
      this.error = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

@media (max-width: 992px) {
  .login {
    padding-top: 5rem;
    height: auto;
  }

  .separator-v {
    display: none;
  }
}

.separator-v {
  border-left: 2px solid #efefef;
  height: 20rem;
  float: right;
}
</style>
